import { trackEvent } from 'tracking/tracking';
import { ViewIds } from '@ardoq/api-types';

const trackDialogDeleteButton = (activeView: ViewIds) =>
  trackEvent('Clicked dialog delete button', {
    activeView,
  });

export { trackDialogDeleteButton };
